const constructionMaterials = [
  { id: "-1", name: "Please select construction material" },
  { id: "6", name: "Bluestone" },
  { id: "3", name: "Brick" },
  { id: "2", name: "Brick veneer" },
  { id: "4", name: "Concrete" },
  { id: "5", name: "Metal" },
  { id: "8", name: "None" },
  { id: "7", name: "Timber" },
  { id: "1", name: "Weatherboard" },
  { id: "9", name: "Other" },
];

export default constructionMaterials;
